import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { getFunctions, httpsCallable } from "firebase/functions";

import { PwgError } from "../../../models/common";
import { User } from "../../../models/users";
import { capitalizeFirstLetter } from "../../../utils/string";
import { firebaseApp } from "../../../firebase/firebaseClient";
import logger from "../../../utils/logger";
import { rSetAlert } from "../../../reducers/session/actions";
const fileDownload = require("js-file-download");

export const generateEnhancePdf = async (user_id: string) => {
  const functions = getFunctions(firebaseApp);
  const storage = getStorage(firebaseApp);
  const onGeneratePdf = httpsCallable(functions, "onGeneratePrepFqPdf");
  await onGeneratePdf();
  const storageRef = ref(
    storage,
    `users/${user_id}/prep_fq_profile/Enhance-Report.pdf`
  );
  const dlUrl = await getDownloadURL(storageRef);
  return dlUrl;
};

export const getDownloadUrl = async (user_id: string) => {
  const storage = getStorage(firebaseApp);
  const storageRef = ref(
    storage,
    `users/${user_id}/prep_fq_profile/Enhance-Report.pdf`
  );
  const dlUrl = await getDownloadURL(storageRef);
  return dlUrl;
};

export const downloadPdf = async (
  dispatch: any,
  t: any,
  user: User,
  downloadUrl: string,
  user_id: string,
  pathname: string
) => {
  dispatch(
    rSetAlert({
      key: new Date().getTime().toString(),
      message: t("common:loading.prepFqReport"),
      type: "info",
      icon: "download",
      duration: 36000,
    })
  );
  try {
    const xhr = new XMLHttpRequest();
    xhr.responseType = "blob";
    xhr.onload = async () => {
      const blob = xhr.response;
      await fileDownload(
        blob,
        `Preparedness Report - ${capitalizeFirstLetter(
          user.first_name
        )} ${capitalizeFirstLetter(user.last_name)}.pdf`
      );
      dispatch(
        rSetAlert({
          key: new Date().getTime().toString(),
          message: t("common:success.prepFqReport"),
          type: "success",
        })
      );
    };
    xhr.onerror = (error) => {
      const pwgError: PwgError = {
        user_id,
        ssr: false,
        context: "downloadPdf: onerror",
        date_created: new Date().getTime(),
        error: error?.toString(),
        pathname,
      };
      logger.e(
        "🚀 ~ file: generatePdf.tsx ~ line 67 ~ downloadPdf ~ error",
        error,
        pwgError
      );
      dispatch(
        rSetAlert({
          key: new Date().getTime().toString(),
          message: t("common:errors.generic"),
          type: "error",
        })
      );
    };
    xhr.open("GET", downloadUrl);
    xhr.send();
  } catch (error) {
    const pwgError: PwgError = {
      user_id,
      ssr: false,
      context: "downloadPdf: onerror",
      date_created: new Date().getTime(),
      error: error?.toString(),
      pathname,
    };
    await logger.e(
      "🚀 ~ file: generatePdf.tsx ~ line 67 ~ downloadPdf ~ error",
      error,
      pwgError
    );
    dispatch(
      rSetAlert({
        key: new Date().getTime().toString(),
        message: t("common:errors.generic"),
        type: "error",
      })
    );
  }
};
